module.exports = __webpack_public_path__ + "images/1893bfe30c2600e045fcedc9846a4323.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/handelsbanken.png
// module id = 1520
// module chunks = 1